<div class="desktop-buy-sell-list" [ngClass]="!userType ? 'not-signed-in' : ''">
  @if (isLoggedIn) {
    <div>
      <div class="list d-flex flex-column gap-2">
        @for (item of items; track item) {
          <div class="list-item">
            <h6 class="mb-2">{{ item.label }}</h6>
            @for (menuItem of item.menuItems; track menuItem) {
              <div class="flex nav-item-container mb-2">
                @if (menuItem.routerLink) {
                  <a
                    class="nav-item p-1 w-100"
                    [routerLink]="menuItem.routerLink ? [menuItem.routerLink] : null"
                    [state]="menuItem.state"
                    (click)="menuItem.command ? menuItem.command() : null">
                    {{ menuItem.label }}
                  </a>
                }
                @if (menuItem.externalLink) {
                  <a
                    class="nav-item p-1 w-100"
                    (click)="redirect(menuItem.externalLink, menuItem.command)"
                    target="_blank"
                    rel="noreferrer noreopen">
                    {{ menuItem.label }}
                  </a>
                }
              </div>
            }
          </div>
        }
      </div>
    </div>
  }

  @if (isBidder()) {
    <div class="footnote mt-25">
      <hr />
      <div>You are currently registered as a {{ getUserTypeName(userType) }}.</div>
      <div>
        To change your account type,
        @if (isClient()) {
          <span>contact <br /><a class="button-link" href="mailto:customerservice&#64;realtybid.com">customerservice&#64;realtybid.com</a></span>
        }
        @if (isBidder()) {
          <span>go to <br /><a class="button-link" routerLink="/my-profile/">Account Details</a></span>
        }
      </div>
    </div>
  }
  @if (!isLoggedIn) {
    <div class="login-signup-container">
      <p><span class="login-signup pointer" routerLink="/login/">Log in or Sign up to access RealtyBid.com features.</span></p>
    </div>
  }
</div>
